// Bump when the car model changes enough that old lap times aren't comparable;
// saved personal bests are stored per physics version.
export const PHYSICS_VERSION = 3;
